module.exports = __webpack_public_path__ + "img/swipes-for-science-logo.279e7d6c.svg";